function $id(id) {
    return document.getElementById(id);
}

function isDom(obj) {
    if (typeof HTMLElement === 'object') {
        return obj instanceof HTMLElement;
    } else {
        return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
    }
}

function hideDom(item) {
    let curDom = item;
    if (!isDom(curDom)) {
        curDom = $id(item);
    }
    curDom.style.display = 'none';
}

function showDom(item, cssStyle) {
    let curDom = item;
    if (!isDom(curDom)) {
        curDom = $id(item);
    }
    curDom.style.display = cssStyle;
}

function addClass(item, cssName) {
    let className = cssName; 
    let curDom = item;

    if (!isDom(curDom)) {
        curDom = $id(item);
    }

    if (Array.isArray(cssName)) {
        className = cssName.join(',');
    }

    curDom.classList.add(className);
}

function removeClass(item, cssName) {
    let className = cssName; 
    let curDom = item;
    if (!isDom(curDom)) {
        curDom = $id(item);
    }

    if (Array.isArray(cssName)) {
        className = cssName.join(',');
    }
   
   
    curDom.classList.remove(className);
}

function toggleClass(item, cssName) {
    let curDom = item;
    if (!isDom(curDom)) {
        curDom = $id(item);
    }

    if (Array.isArray(cssName)) {
        cssName.forEach(curCss => {
            curDom.classList.toggle(curCss);
        });
    } else {
        curDom.classList.toggle(cssName);
    }
}

function appendDom(parent, dom) {
    if (typeof dom === 'string') {
        var temp = document.createElement('div');
        temp.innerHTML = dom;
        // 防止元素太多 进行提速
        var frag = document.createDocumentFragment();
        while (temp.firstChild) {
            frag.appendChild(temp.firstChild);
        }
        parent.appendChild(frag);
    }
    else {
        parent.appendChild(dom);
    }
}



export { 
    $id, 
    appendDom, 
    hideDom, 
    showDom,
    addClass,
    removeClass,
    toggleClass
 }